import React from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import {
  SUPPORTED_LANGUAGES,
  SupportedLanguage,
  setStoredLanguage,
  setManualSwitchFlag,
} from "@/i18n";
import { setLanguageApi } from "@/api/organization";
import useUserPermission from "@/hooks/useUserPermission";

const LanguageSelect: React.FC = () => {
  const { i18n } = useTranslation();
  const { updateLanguage } = useUserPermission();

  const handleLanguageChange = async (value: SupportedLanguage) => {
    if (value === i18n.language) {
      return;
    }
    
    try {
      // 切换语言
      i18n.changeLanguage(value);
      setStoredLanguage(value);
      updateLanguage(value);
      setManualSwitchFlag();
      
      // 调用 API 更新服务器端语言设置
      try {
        await setLanguageApi({ language: value });
      } catch (apiError) {
        // console.error('语言设置API调用失败:', apiError);
      }
      
      // 重新加载页面以应用Clerk的本地化配置
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
      // console.error('切换语言失败:', error);
    }
  };

  // 将语言选项转换为options格式
  const options = Object.entries(SUPPORTED_LANGUAGES).map(([key, label]) => ({
    value: key,
    label: label
  }));

  return (
    <div style={{ width: '260px', marginTop: '32px' }}>
      <Select
        value={i18n.language as SupportedLanguage}
        onChange={handleLanguageChange}
        size="large"
        className="w-full"
        options={options}
        dropdownStyle={{ zIndex: 9999 }}
        getPopupContainer={(trigger) => trigger.parentElement || document.body}
      />
    </div>
  );
};

export default LanguageSelect;
